// import { defineStore } from 'pinia';
// import { ref } from 'vue';

// export const useAuthStore = defineStore('auth', () => {
//     const token = ref<string | null>(localStorage.getItem('token'));

//     function setToken(t: string) {
//         token.value = t;
//         localStorage.setItem('token', t);
//     }

//     function logout() {
//         token.value = null;
//         localStorage.removeItem('token');
//     }

//     return { token, setToken, logout };
// });


import { defineStore } from 'pinia';
import { ref } from 'vue';

export const useAuthStore = defineStore('auth', () => {
    const token = ref<string | null>(localStorage.getItem('token'));

    // 登录成功时调用
    function setToken(t: string) {
        token.value = t;
        localStorage.setItem('token', t);
    }

    // 退出登录
    function logout() {
        token.value = null;
        localStorage.removeItem('token');
    }

    // 页面一进来就打印 token，方便排查
    console.log('当前 token:', token.value);

    return { token, setToken, logout };
});